import { authQuery } from "../baseQuery";
import { SignInRequest, SignInResponse } from "./models";

const signIn = (params: SignInRequest) =>
  authQuery.post<SignInResponse>("/authorization", params);

export const AuthService = {
  signIn,
};
